import StatusBadge from './status-badge';
import './status-badge.scss';

export default StatusBadge;
